import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsPortalRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-portal',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
	exact: true,
};
